<template>
  <span class="tag" :class="tagClassName">
    <slot name="content"></slot>
    <slot name="post-icon"></slot>
  </span>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    isRounded: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
  },

  computed: {
    tagClassName() {
      let classNameTemporary = ''

      switch (this.variant) {
        case 'primary':
          classNameTemporary = 'is-primary'
          break;

        case 'primary-outlined':
          classNameTemporary = 'is-primary-outlined'
          break;

        case 'primary-light':
          classNameTemporary = 'has-background-lightprimary'
          break;

        case 'secondary':
          classNameTemporary = 'is-secondary'
          break;

        case 'secondary-light':
          classNameTemporary = 'has-background-lightyellow'
          break;

        case 'default':
          classNameTemporary = 'default'
          break;

        case 'white':
          classNameTemporary = 'white'
          break;

        case 'blue-outlined':
          classNameTemporary = 'blue-outlined'
          break;
      
        default:
          classNameTemporary = '';
          break;
      }

      const roundedClass = this.isRounded ? 'is-rounded' : ''

      return `${classNameTemporary} ${roundedClass} ${this.className}`
    }
  }
}
</script>

<style scoped>
.tag {
  padding: 8px 15px;
  border-radius: 8px;
}

.tag.white {
  background-color: white;
}
</style>
